/* eslint-disable @typescript-eslint/no-explicit-any */
import API_PATH from "./api-routes";
import { LANG } from "./constant";
import api from "./Interceptor";

export class ApiService {
  lang = LANG.english;
  constructor(lang: string) {
    this.lang = lang;
  }

  //   mst data
  getMasterData = async () => {
    try {
      const response = await api.get(`${API_PATH.MASTER}`, {
        params: { lang: this.lang },
      });
      if (response.status === 200) {
        return response.data?.data.data;
      } else {
        console.error("Error fetching master data:", response.statusText);
        return null;
      }
    } catch (error: any) {
      console.log("Error fetching master data:", error.message);
    }
  };

  //   sad granth data
  getSadGranth = async () => {
    try {
      const response = await api.get(`${API_PATH.SAD_GRANTH}`, {
        params: { lang: this.lang },
      });
      return response.data?.data;
    } catch (error: any) {
      console.log("Error fetching Sad Granth data:", error.message);
    }
  };

  //  get sad granth base on slug
  getSadGranthBaseOnSlug = async (slug: string) => {
    try {
      const response = await api.get(`${API_PATH.SAD_GRANTH}/${slug}`, {
        params: { lang: this.lang },
      });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching Sad Granth Base On Slug data:", response.statusText);
        throw new Error("Error fetching Sad Granth Base On Slug data");
      }
    } catch (error: any) {
      console.log("Error fetching Sad Granth Base On slug data:", error.message);
    }
  };

  // get article data
  getArticleDataBaseOnId = async (slug: string, id: string) => {
    try {
      const response = await api.get(`${API_PATH.ARTICLE}/${slug}/${id}`, {
        params: { lang: this.lang },
      });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching Blog:", response.statusText);
        throw new Error("Error fetching Blog data");
      }
    } catch (error: any) {
      console.log("Error fetching Blog data:", error.message);
    }
  };

  // get announcement data
  getAnnouncementData = async (slug: string) => {
    try {
      const response = await api.get(`${API_PATH.ARTICLE}/${slug}`, {
        params: { lang: this.lang },
      });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching announcement:", response.statusText);
        throw new Error("Error fetching announcement data");
      }
    } catch (error: any) {
      console.log("Error fetching announcement data:", error.message);
    }
  };

  // get related article data
  getRelatedArticle = async (id: string) => {
    try {
      const response = await api.get(`${API_PATH.ARTICLE}/related/${id}`, {
        params: { lang: this.lang },
      });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching Related Article:", response.statusText);
        throw new Error("Error fetching Related Article");
      }
    } catch (error: any) {
      console.log("Error fetching Related Article:", error.message);
    }
  };

  // get doha chopai data
  getDohaChopaiData = async (params: { pageIndex: number; pageSize: number; id?: number | null }) => {
    const paramsObj = {
      lang: this.lang,
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.DOHA_CHOPAI}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching Doha chopai:", response.statusText);
        throw new Error("Error fetching Doha chopai");
      }
    } catch (error: any) {
      console.log("Error fetching doha chopai:", error.message);
    }
  };

  getReelWallpaper = async (params: { pageIndex: number; pageSize: number }) => {
    const paramsObj = {
      lang: this.lang,
      ...params,
    };
    try {
      // chopai-background
      const response = await api.get(`${API_PATH.SATSANG_MEDIA}/chopai_background`, { params: paramsObj });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching chopai background:", response.statusText);
        throw new Error("Error fetching chopai background");
      }
    } catch (error: any) {
      console.log("Error fetching chopai background:", error.message);
    }
  };

  //get home screen data
  getHomeScreenData = async () => {
    const paramsObj = {
      lang: this.lang,
    };
    try {
      const response = await api.get(`${API_PATH.HOME}?mode=web`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching home screen data:", response.statusText);
        throw new Error("Error fetching home screen data");
      }
    } catch (error: any) {
      console.log("Error fetching home screen data:", error.message);
    }
  };

  getLiveData = async () => {
    const paramsObj = {
      lang: this.lang,
    };
    try {
      const response = await api.get(`${API_PATH.LIVE}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching live data:", response.statusText);
        throw new Error("Error fetching live data");
      }
    } catch (error: any) {
      console.log("Error fetching home screen data:", error.message);
    }
  };

  //get satsang-media data
  getSatsangMediaData = async (
    params: {
      pageIndex: number;
      pageSize: number;
      subCategory: number | undefined;
    },
    mediaType: string,
  ) => {
    const paramsObj = {
      lang: this.lang,
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.SATSANG_MEDIA}/${mediaType}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response?.data?.data;
      } else {
        console.error("Error fetching satsang media:", response.statusText);
        throw new Error("Error fetching satsang media:");
      }
    } catch (error: any) {
      console.log("Error fetching satsangMedia:", error.message);
    }
  };

  //get dailydarshan data
  getDailyDarshanData = async (
    mandir: string,
    params: {
      start_date: string;
      n_days: number;
    },
  ) => {
    const paramsObj = {
      lang: this.lang,
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.DAILY_DARSHAN}/${mandir}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching daily darshan data: ", response.statusText);
        throw new Error("Error fetching daily darshan data");
      }
    } catch (error: any) {
      console.log("Error fetching daily darshan data: ", error.message);
    }
  };

  //get available dates for dailydarshan
  getAvailableDataDatesArray = async (mandir: string) => {
    try {
      const response = await api.get(`${API_PATH.AVAILBALE_DATES}/${mandir}`);
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching daily darshan avialable date dates: ", response.statusText);
        throw new Error("Error fetching daily darshan avialable date dates:");
      }
    } catch (error: any) {
      console.log("Error fetching daily darshan avialable date dates: ", error.message);
    }
  };

  //get kirtan lyrics data
  getKirtanLyricsData = async (params: {
    raag_dhal: number[] | null;
    bhav: number[] | null;
    rachayta: number[] | null;
    k_book?: number[] | null;
    k_place?: number[] | null;
    k_prasang?: number[] | null;
    pageIndex: number;
    pageSize: number;
  }) => {
    const paramsObj = {
      lang: this.lang,
      sortBy: this.lang === "en" ? "en_char" : "gu_char",
      sort: "asc",
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.KIRTAN_LYRICS}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching kirtan lyrics data:", response.statusText);
      }
    } catch (error: any) {
      console.log("Error fetching kirtan lyrics data:", error.message);
    }
  };

  // get kirtan lyrics sync data
  getKirtanLyricsSyncData = async (date: string | null) => {
    const paramsObj = {
      date,
    };
    try {
      const response = await api.get(`${API_PATH.KIRTAN_LYRICS_SYNC}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching kirtan lyrics sync data:", response.statusText);
        throw new Error("Error fetching kirtan lyrics sync data");
      }
    } catch (error: any) {
      console.log("Error fetching kirtan lyrics sync data:", error.message);
    }
  };

  // get kirtan lyrics pad list based on selected kirtan id
  getKirtanLyricsPadListOfKirtan = async (id: number) => {
    const paramsObj = {
      lang: this.lang,
    };
    try {
      const response = await api.get(`${API_PATH.KIRTAN_LYRICS}/${id}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data.rows;
      } else {
        console.error("Error fetching kirtan pad lyrics data:", response.statusText);
        // throw new Error("Error fetching kirtan lyrics data");
      }
    } catch (error: any) {
      console.log("Error fetching kirtan pad lyrics data:", error.message);
    }
  };

  //get charcter of available kirtan
  getKirtanCharacters = async () => {
    const paramsObj = {
      lang: this.lang,
    };
    try {
      const response = await api.get(`${API_PATH.KIRTAN_CHARACTERS}`, {
        params: paramsObj,
      });
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching kirtan lyrics characters:", response.statusText);
        throw new Error("Error fetching kirtan lyrics characters");
      }
    } catch (error: any) {
      console.log("Error fetching kirtan lyrics characters", error.message);
    }
  };

  //getBlog data
  getBlogData = async (params: { pageIndex: number; pageSize: number; category: number | null; author: number | null }) => {
    const paramsObj = {
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.BLOG}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error: any) {
      console.log("Error fetching blog data", error.message);
    }
  };

  //get news data
  getNewsData = async (params: { pageIndex: number; pageSize: number }) => {
    const paramsObj = {
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.NEWS}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error: any) {
      console.log("Error fetching blog data", error.message);
    }
  };

  //get satsang-sevak data
  getSatsangSevakData = async (params: { pageIndex: number; pageSize: number }) => {
    const paramsObj = {
      lang: this.lang,
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.SATSANG_SEVAK_LIST}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error: any) {
      console.log("Error fetching blog data", error.message);
    }
  };

  //get get category video
  getVideoCategory = async (category: string) => {
    const paramsObj = { lang: this.lang };
    try {
      const response = await api.get(`${API_PATH.VIDEO_CATEGORY}/${category}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error: any) {
      console.log("Error fetching video category error", error.message);
    }
  };

  // get playlist for specific video category
  getPlaylistVideoBaseOnCategory = async ({
    base_slug,
    category_slug,
    slug,
    pageIndex,
    pageSize,
    trackId,
    media,
    last_slug,
    sortDirection,
    sortColumn,
  }: {
    base_slug: string;
    category_slug: string;
    slug?: string | null;
    pageIndex: number;
    pageSize: number;
    trackId?: number | null;
    media: "video" | "audio";
    last_slug?: string | null;
    sortDirection?: string | null;
    sortColumn?: string | null;
  }) => {
    const paramsObj = { lang: this.lang, pageIndex, pageSize, t: trackId, media, sortDirection, sortColumn };

    const URL = slug
      ? last_slug
        ? `${API_PATH.VIDEO_PLAYLIST_DETAILS_BASE_CATEGORY}/${base_slug}/${category_slug}/${slug}/${last_slug}`
        : `${API_PATH.VIDEO_PLAYLIST_DETAILS_BASE_CATEGORY}/${base_slug}/${category_slug}/${slug}`
      : `${API_PATH.VIDEO_PLAYLIST_DETAILS_BASE_CATEGORY}/${base_slug}/${category_slug}`;

    const URLArray = URL.split("/");

    if (URLArray.length > 1 && URLArray[1].length === 0) {
      return null;
    }

    try {
      // Remove "t" if media is audio
      if (media === "audio") {
        delete paramsObj.t;
      }

      const response = await api.get(URL, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response?.data?.data;
      } else {
        // set empty array if no data found
        return null;
      }
    } catch (error: any) {
      console.log("Error fetching video category error", error.message);
    }
  };

  getRelatedPlaylist = async (slug: string) => {
    try {
      const response = await api.get(`${API_PATH.VIDEO_PLAYLIST_DETAILS_BASE_CATEGORY}/${slug}`, {
        params: { lang: this.lang },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching related playlist data", error.message);
      return [];
    }
  };

  //get recipe data
  getRecipeData = async (params: { pageIndex: number; pageSize: number; subCategory: number | null }) => {
    const paramsObj = {
      lang: this.lang,
      ...params,
    };
    try {
      const response = await api.get(`${API_PATH.RECIPE_LIST}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error: any) {
      console.log("Error fetching recipe data", error.message);
    }
  };

  //get recipe details
  getRecipeDetails = async (recipeId: string) => {
    const paramsObj = {
      lang: this.lang,
    };
    try {
      const response = await api.get(`${API_PATH.RECIPE_DETAILS}/${recipeId}`, {
        params: paramsObj,
      });

      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching recipe details:", response.statusText);
        throw new Error("Error fetching recipe details");
      }
    } catch (error: any) {
      console.log("Error fetching recipe details:", error.message);
    }
  };

  //get quiz data
  getQuizData = async () => {
    try {
      const response = await api.get(API_PATH.QUIZ);

      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching quiz data:", response.statusText);
        throw new Error("Error fetching quiz data");
      }
    } catch (error: any) {
      console.log("Error fetching quiz data:", error.message);
    }
  };

  // get profile data
  getProfileData = async () => {
    try {
      const response = await api.get(API_PATH.CONTENT_USER);
      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching profile data:", response.statusText);
        throw new Error("Error fetching profile data");
      }
    } catch (error: any) {
      console.log("Error fetching profile data:", error.message);
    }
  };

  // get recent updates
  getRecentUpdates = async () => {
    try {
      const response = await api.get(API_PATH.RECENT_UPDATES, {
        params: { lang: this.lang },
      });

      if (response.status === 200) {
        return response.data.data;
      } else {
        console.error("Error fetching recent updates:", response.statusText);
        throw new Error("Error fetching recent updates");
      }
    } catch (error: any) {
      console.log("Error fetching recent updates:", error.message);
    }
  };

  getVideoTrackBaseOnId = async (id: number, media: "video" | "audio") => {
    try {
      const response = await api.get(`${API_PATH.VIDEO_BASE_ON_ID}/${id}`, {
        params: { lang: this.lang, media },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching related video track data", error.message);
      return [];
    }
  };

  getAudioUrlToNavigate = async (id: number) => {
    try {
      const response = await api.get(`${API_PATH.GET_AUDIO_URL}/${id}`, {
        params: { lang: this.lang },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching audio URL", error.message);
      return null;
    }
  };

  getKundalAartiTime = async () => {
    try {
      const response = await api.get(`${API_PATH.CONTACT_US_KUNDAL_ARTI_TIME}`, {
        params: { lang: this.lang },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching aarti time", error.message);
      return null;
    }
  };

  getVadodaraAartiTime = async () => {
    try {
      const response = await api.get(`${API_PATH.CONTACT_US_VADODARA_ARTI_TIME}`, {
        params: { lang: this.lang },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching aarti time", error.message);
      return null;
    }
  };

  getNityaNiyam = async () => {
    try {
      const response = await api.get(`${API_PATH.NITY_NIYAM}`, {
        params: { lang: this.lang },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching related playlist data", error.message);
      return [];
    }
  };

  getNirnayData = async (params: { start_date: string; end_date: string }) => {
    try {
      const response = await api.get(`${API_PATH.NIRNAY}`, {
        params: { lang: this.lang, ...params },
      });

      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error: any) {
      console.log("Error fetching nirnay data", error.message);
      return [];
    }
  };
}
